<template>
    <div class="EvaluateContainer">
        <div class="UserInfo">
            <van-row>
                <van-col>
                    <van-image
                        round
                        width="2rem"
                        height="2rem"
                        :src="info.user_info && info.user_info.avatar"
                        fit="cover"
                    />
                </van-col>
                <van-col style="height: 2rem;margin-left: 20px;">
                    <van-row class="NikeName FlexCol">
                        {{info.user_info && info.user_info.nickname}}
                    </van-row>
                    <van-row class="CreateAt">
                        {{info.created_at}}
                    </van-row>
                </van-col>
            </van-row>
        </div>
        <div class="Evaluate">
            {{info.evaluate || '该用户未写评论'}}
        </div>
        <div class="Images">
            <van-col 
                v-for="image in info.images_info" 
                :key="image.file_md5"
                :span="8"
                class="ImagesCol"
            >
                <van-image
                    :src="image.url"
                    fit="cover"
                    class="Image"
					@click="preview(image.url)"
                >
                </van-image>
            </van-col>
        </div>
    </div>
</template>

<script>
	import { ImagePreview } from 'vant';
    import api from "../../assets/js/api";

    export default {
        name: "Evaluate",
        data(){
            return {
                isLoading: false,
                info: {

                },
                image: {
                    file: '',
                    check: []
                },
            };
        },
        created() {
            let self = this;
            if (this.$route.query.order_no != 'null' && this.$route.query.order_no) {
                this.isLoading = true;
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/order/evaluate_detail', {
                    order_no : self.$route.query.order_no,
                }).then(res => {
                    self.info = res.data;
                }).finally(() => {
                    self.isLoading = false;
                    self.$toast.clear(loading);
                })
            }
        },
        methods : {
			preview(url) {
				ImagePreview([url])
			}
        },
    }
</script>

<style lang="scss" scoped>
    .EvaluateContainer {
        width: 100%;
		min-height: 100%;
        padding: 10px;
        box-sizing: border-box;
        background: #fff;

        .UserInfo {
            width: 100%;

            .NikeName {
                font-size: 20px;
                color: #333;
                height: 70%;
            }

            .CreateAt {
                font-size: 12px;
                color: #999;
                height: 30%;
            }
        }

        .Evaluate {
            width: 100%;
            font-size: 14px;
            color: #999;
            margin: 20px 0;
            word-wrap:break-word;
			min-height: 50px;
        }

        .Images {
            width: 100%;
            padding-bottom: 20px;

            .ImagesCol {
                padding: 5px;
                box-sizing: border-box;

                .Image {
                    width: 100%;
                    padding-bottom: 100%;
                    height: 0;

                    /deep/ .van-image__img {
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                }
            }

        }
    }

    .FlexCol {
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/ShowEvaluate.vue